import { endPoints } from 'api/';
import { GET_USER_WAREHOUSES } from 'actions/types';

/**
  @description Gets the warehouses a user is assigned to
  @param {string} userId
  @returns {{ id: string, warehouse_ids: string[] }}
 */
function getUserWarehouses(userId) {
  /**
    @param {Function} dispatch
   */
  return (dispatch) => {
    const action = {
      type: GET_USER_WAREHOUSES,
      /**
        @param {Function} apiClient
       */
      request: async (apiClient) => {
        const assignment = await apiClient(
          endPoints.GET_USER_WAREHOUSES,
          {},
          { userId },
        );

        return assignment;
      },
    };

    dispatch(action);
  };
}

export default getUserWarehouses;
